import(/* webpackMode: "eager" */ "/app/src/app/(dashboard)/oversikt/page.tsx");
